import { INPLACE_VOLUMES_INDEX_WITH_VALUES_SCHEMA } from "./definitions/InplaceVolumesIndexWithValues";
import { INPLACE_VOLUMES_PLOT_OPTIONS_SCHEMA } from "./definitions/InplaceVolumesPlotOptions";
import { VEC2_SCHEMA } from "./definitions/Vec2";
import { VEC3_SCHEMA } from "./definitions/Vec3";
import { VIEW_STATE_SCHEMA } from "./definitions/ViewState";

export const schemaRegistry = {
    Vec2: VEC2_SCHEMA,
    Vec3: VEC3_SCHEMA,
    ViewState: VIEW_STATE_SCHEMA,
    InplaceVolumesIndexWithValues: INPLACE_VOLUMES_INDEX_WITH_VALUES_SCHEMA,
    InplaceVolumesPlotOptions: INPLACE_VOLUMES_PLOT_OPTIONS_SCHEMA,
};
